import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const messages = {   
    'en': {
        'accueil':{
            'title':'Get a quote for your project!',
            'youAre':'You are',
            'individual':'An individual',
            'professional':'A professional',
        },
        'particulierpage1':{
            'title':'Enter your details',
            'firstName':'FIRST NAME',
            'lastName':'LAST NAME',
            'email':'EMAIL',
            'phone':'PHONE NUMBER',
            'postalCode':'POSTAL CODE',
            'city':'CITY', 
            'message':'By clicking on NEXT you authorize us to send you information about Ramo news',
            'required':'*Required', 
            'errorMsg':'This field is required',
            'emailErrorMsg':'Please enter a valid email',
            'infoletter':'Stay informed about Ramo\'s news',
        }, 
        'particulierPage2':{
            'title':'What length of fence do you need?',
            'ft':'ft',
            'lenghtError':'Your fence length must be greater than 0'
        },
        'particulierPage3':{
            'title':'How many doors will be installed?'
        },
        'particulierPage4':{
            'title1':'Your approximate estimate for a project of ',
            'title2':'ft and ',
            'title3':'door (s) ',
            'height':'Height',
            'withInstallation':'With installation**',
            'withoutInstallation':'Price fence*',
            'choose':'Choose this option',
            'message1':'By clicking on CONNECT, you will be contacted by an installer-distributor for a detailed quote.',
            'message2':'** Including panels, posts, labor, delivery, drilling and concrete.',
            'message3':'* Includes panels only. Shipping costs not included.',
            'message4':'If the installation is done on a "frost" fence, on a deck or patio, the price will be less expensive',
            'feets':'feets',
            'ModularFence':'Modular fence',
            'BraidedFence':'Braided fence',
           
        },
        'confirmation':{
            'thx':'Thank you for your interest in our Quebec fences, sustainable and ecological.',
            'message':'You will receive a confirmation email and you will be contacted by our installer / distributor closest to you. Confirmation may be found in spam emails. Please take care to consult them.',
            'visit':'VISIT THE RAMO WEBSITE',
        },
        'proPage1':{
            'title':'Enter your details',
            'firstName':'FIRST NAME',
            'lastName':'LAST NAME',
            'enterprise':'COMPANY',
            'enterpriseName':'COMPANY NAME',
            'email':'EMAIL',
            'phone':'PHONE NUMBER',
            'postalCode':'POSTAL CODE',
            'city':'CITY', 
            'message':'By clicking on NEXT you authorize us to send you information about Ramo news',
            'required':'*Required', 
            'errorMsg':'This field is required',
            'emailErrorMsg':'Please enter a valid email',
           
        }, 
        'proPage2':{
            'title':'What length of fence do you need?',
            'ft':'ft',
            'lenghtError':'Your fence length must be greater than 0'
        },
        'return':'Return',
        'next':'Next',
        'knowMyPrice':'Know my price',
        'connect':'Connect',

    },
    'fr':{
        'accueil':{
            'title':'Obtenez un estimé de votre projet!',
            'youAre':'Vous êtes:',
            'individual':'Particulier',
            'professional':'Professionnel',
        },
        'particulierpage1':{
            'title':'Entrez vos coordonnées',
            'firstName':'PRÉNOM',
            'lastName':'NOM',
            'email':'COURRIEL',
            'phone':'TÉLÉPHONE',
            'postalCode':'CODE POSTAL',
            'city':'VILLE', 
            'message':'En cliquant sur SUIVANT vous nous autorisez à vous envoyer de l\'information concernant les nouveautés de Ramo',
            'required':'*champs obligatoire',
            'errorMsg':'Ce champs est obligatoire',
            'emailErrorMsg':'S\'il vous plait entrer un courriel valide',
            'infoletter':'Restez informé des nouveautés de Ramo ',
        }, 
        'particulierPage2':{
            'title':'Quelle longueur de clôture avez-vous besoin approximativement?',
            'ft':'pi',
            'lenghtError':'Votre longueur de clôture doit être supérieur à 0'
        },
        'particulierPage3':{
            'title':'Combien de portes seront installées?'
        },
        'particulierPage4':{
            'title1':'Votre estimé approximatif pour un projet de ',
            'title2':'pi et ',
            'title3':' porte(s) ',
            'height':'Hauteur',
            'withInstallation':'Avec installation**',
            'withoutInstallation':'Prix clôture*',
            'choose':'Choisir cette option',
            'message1':'En cliquant sur MISE EN RELATION, vous serez contacté par un installateur-distributeur pour une soumission détaillée. ',
            'message2':'** Comprenant les panneaux, les poteaux, la main d’oeuvre, la livraison, le forage et le béton.',
            'message3':'* Comprend les panneaux seulement. Frais de livraison non compris. ',
            'message4':'Si l’installation se fait sur clôture « frost », sur deck ou patio, le prix sera moins dispendieux',
            'feets':'pieds',
            'ModularFence':'Clotûre modulaire',
            'BraidedFence':'Clotûre tressée',
         
        },
        'proPage1':{
            'title':'Entrez vos coordonnées',
            'firstName':'PRÉNOM',
            'lastName':'NOM',
            'enterprise':'ENTREPRISE',
            'enterpriseName':'NOM D\'ENTREPRISE',
            'email':'COURRIEL',
            'phone':'TÉLÉPHONE',
            'postalCode':'CODE POSTAL',
            'city':'VILLE', 
            'message':'En cliquant sur SUIVANT vous nous autorisez à vous envoyer de l\'information concernant les nouveautés de Ramo',
            'required':'*champs obligatoire',
            'errorMsg':'Ce champs est obligatoire',
            'emailErrorMsg':'S\'il vous plait entrer un courriel valide',
           
        }, 
        'proPage2':{
            'title':'Quelle longueur de cloture avez-vous besoin?',
            'ft':'pi',
            'lenghtError':'Votre longueur de clôture doit être supérieur à 0'
        },
        'confirmation':{
            'thx':'Merci pour l\'intérêt pour nos clôtures québécoises, durables et écologiques',
            'message':'Vous recevrez un courriel de confirmation et vous serez contacté par notre installateur / distributeur le plus proche de chez vous. Il est possible que la confirmation se trouve dans les courriels indésirables. Veuillez prendre le soin de les consulter.',
            'visit':'VISITER LE SITE RAMO',
        },
        'return':'Retour',
        'next':'Suivant',
        'knowMyPrice':' Connaitre mon prix',
        'connect':'Mise en relation',
    }
};

export const i18n = new VueI18n({    locale: 'fr', // set locale    
fallbackLocale: 'en', // set fallback locale    
messages, // set locale messages
});


// WEBPACK FOOTER //
// ./src/plugins/i18n.js